module.exports = __webpack_public_path__ + "static/img/question3-3.c1cb401.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/question3-3.png
// module id = PUvR
// module chunks = 1